import { IBookmark } from '../models/Bookmarks/IBookmark';
import { IBookmarksContainer } from '../models/Bookmarks/IBookmarksContainer';
import { IBookmarkUpdate } from '../models/Bookmarks/IBookmarkUpdate';

function bookmarkServiceMock() {
  function getBookmarksPaged(
    ssoUUId: string,
    bookmarkType: number,
    sortOrder: number,
    pageSize: number,
    pageNumber: number
  ): any {
    let bookmarksMock: IBookmark[] = [
      {
        bookmarkId: 952826,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=2a78842a-1d0c-4987-8bed-c68c7540351d&siteType=1',
        itemGuid: '2a78842a-1d0c-4987-8bed-c68c7540351d',
        headline: 'What to Expect Now that OSHA Has Withdrawn Its Vaccine-or-Testing ETS',
        subheading: '',
        notes: 'ccvvvvcc\n',
        addedBy: 'WebUser',
        addedDate: '2022-01-26T16:07:54.39',
        updatedBy: 'Webuser',
        updatedDate: '2022-05-10T11:46:14.667',
        articleId: '2a78842a-1d0c-4987-8bed-c68c7540351d',
      },
      {
        bookmarkId: 935180,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=84fe72e9-723b-4e60-8bd6-7ad3efe1bfbb&siteType=1',
        itemGuid: '84fe72e9-723b-4e60-8bd6-7ad3efe1bfbb',
        headline: 'IRS Extends Deadline for Distributing ACA Forms to Employees',
        subheading: 'Employers can take advantage of automatic 30-day extension to deliver forms ',
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2021-12-04T03:24:54.513',
        updatedBy: 'Webuser',
        updatedDate: '2022-04-26T14:05:37.123',
        articleId: '84fe72e9-723b-4e60-8bd6-7ad3efe1bfbb',
      },
      {
        bookmarkId: 913109,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=82eb9edd-de21-4ebe-b8b7-66d476c16ff3&siteType=1',
        itemGuid: '82eb9edd-de21-4ebe-b8b7-66d476c16ff3',
        headline: 'New DE&I Roles Spike After Racial Justice Protests',
        subheading: '',
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2021-10-14T09:56:07.813',
        updatedBy: 'Webuser',
        updatedDate: '2022-03-22T09:54:10.367',
        articleId: '82eb9edd-de21-4ebe-b8b7-66d476c16ff3',
      },
      {
        bookmarkId: 809205,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=05802c75-60fd-4bf9-8522-ccfcf1987b8c&siteType=1',
        itemGuid: '05802c75-60fd-4bf9-8522-ccfcf1987b8c',
        headline: 'Academic Department Head',
        subheading: '',
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2021-01-27T17:35:25.837',
        updatedBy: null,
        updatedDate: null,
        articleId: '05802c75-60fd-4bf9-8522-ccfcf1987b8c',
      },
      {
        bookmarkId: 700683,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=36cb8dbc-686c-4754-83b9-c05f3b7419f8&siteType=1',
        itemGuid: '36cb8dbc-686c-4754-83b9-c05f3b7419f8',
        headline: 'Managing H-1B Workers During COVID-19',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-04-24T14:12:03.893',
        updatedBy: 'Webuser',
        updatedDate: '2022-03-22T09:54:05.81',
        articleId: '36cb8dbc-686c-4754-83b9-c05f3b7419f8',
      },
      {
        bookmarkId: 698239,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=f7c6b292-3cbd-4bb7-b79c-860718003fc4&siteType=1',
        itemGuid: 'f7c6b292-3cbd-4bb7-b79c-860718003fc4',
        headline: 'Use Caution When Cutting Exempt Employees’ Salary',
        subheading: '',
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-04-21T17:01:37.59',
        updatedBy: null,
        updatedDate: null,
        articleId: 'f7c6b292-3cbd-4bb7-b79c-860718003fc4',
      },
      {
        bookmarkId: 691994,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=07994de2-4d73-47c6-831a-6d7def2b5d93&siteType=1',
        itemGuid: '07994de2-4d73-47c6-831a-6d7def2b5d93',
        headline: 'Student Teaching Assistant May Have Been University Employee',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-04-08T19:23:22.457',
        updatedBy: null,
        updatedDate: null,
        articleId: '07994de2-4d73-47c6-831a-6d7def2b5d93',
      },
      {
        bookmarkId: 691993,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=8fa1227b-31d4-40b8-878c-46b5a29e00ea&siteType=1',
        itemGuid: '8fa1227b-31d4-40b8-878c-46b5a29e00ea',
        headline: 'IRS and DOL Unveil Employer Tax Credits for Coronavirus-Related Leaves',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-04-08T19:23:04.067',
        updatedBy: null,
        updatedDate: null,
        articleId: '8fa1227b-31d4-40b8-878c-46b5a29e00ea',
      },
      {
        bookmarkId: 660165,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=4e4dbd64-793a-43ff-9699-645076afa703&siteType=1',
        itemGuid: '4e4dbd64-793a-43ff-9699-645076afa703',
        headline: 'Sacramento Joins Cities that Mandate Panic Buttons for Hotel Workers',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T17:38:20.66',
        updatedBy: null,
        updatedDate: null,
        articleId: '4e4dbd64-793a-43ff-9699-645076afa703',
      },
      {
        bookmarkId: 659952,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=4e2321b0-7b00-478e-91cf-ad00e7128487&siteType=1',
        itemGuid: '4e2321b0-7b00-478e-91cf-ad00e7128487',
        headline: 'What to Expect: 2020 HR Tech Trends',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T14:23:51.58',
        updatedBy: null,
        updatedDate: null,
        articleId: '4e2321b0-7b00-478e-91cf-ad00e7128487',
      },
      {
        bookmarkId: 659936,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=22d2844d-324d-445b-9c7f-438084f66bb1&siteType=1',
        itemGuid: '22d2844d-324d-445b-9c7f-438084f66bb1',
        headline: 'Implementing AI Technology for HR',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T14:08:09.88',
        updatedBy: null,
        updatedDate: null,
        articleId: '22d2844d-324d-445b-9c7f-438084f66bb1',
      },
      {
        bookmarkId: 659935,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=0b17bddf-4eab-4f6f-b5e6-f2338fcaaf74&siteType=1',
        itemGuid: '0b17bddf-4eab-4f6f-b5e6-f2338fcaaf74',
        headline: 'Organizations Will Need Data Analytics to Survive',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T14:07:33.15',
        updatedBy: null,
        updatedDate: null,
        articleId: '0b17bddf-4eab-4f6f-b5e6-f2338fcaaf74',
      },
      {
        bookmarkId: 659934,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=61d29418-260b-4aab-b7fe-d82904559ef2&siteType=1',
        itemGuid: '61d29418-260b-4aab-b7fe-d82904559ef2',
        headline: 'How 5G Will Reshape Work',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T14:07:26.147',
        updatedBy: null,
        updatedDate: null,
        articleId: '61d29418-260b-4aab-b7fe-d82904559ef2',
      },
      {
        bookmarkId: 659932,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=0e6147e1-f6d8-4489-99b8-222007b2df6f&siteType=1',
        itemGuid: '0e6147e1-f6d8-4489-99b8-222007b2df6f',
        headline: 'Quebec: Right to Add Union Message to Work E-Mail Upheld',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T14:07:00.14',
        updatedBy: null,
        updatedDate: null,
        articleId: '0e6147e1-f6d8-4489-99b8-222007b2df6f',
      },
      {
        bookmarkId: 659931,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=b2499785-56e7-4e98-9ae2-fef6901f2b25&siteType=1',
        itemGuid: 'b2499785-56e7-4e98-9ae2-fef6901f2b25',
        headline: 'Black Tech Employees Continue to Face Workplace Racism',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T14:06:47.523',
        updatedBy: null,
        updatedDate: null,
        articleId: 'b2499785-56e7-4e98-9ae2-fef6901f2b25',
      },
      {
        bookmarkId: 659930,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=e8267db2-bd94-44bd-b8ad-c32dee096aea&siteType=1',
        itemGuid: 'e8267db2-bd94-44bd-b8ad-c32dee096aea',
        headline: 'Should Employers Let Workers Report FMLA Absences by Text?',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T14:06:44.393',
        updatedBy: null,
        updatedDate: null,
        articleId: 'e8267db2-bd94-44bd-b8ad-c32dee096aea',
      },
      {
        bookmarkId: 659928,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=7479d971-a4cf-404e-8f7b-ff735a02f310&siteType=1',
        itemGuid: '7479d971-a4cf-404e-8f7b-ff735a02f310',
        headline: 'Quebec: Considerations When Conducting Surreptitious Video Surveillance',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T14:06:40.197',
        updatedBy: null,
        updatedDate: null,
        articleId: '7479d971-a4cf-404e-8f7b-ff735a02f310',
      },
      {
        bookmarkId: 659927,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=4af0b22a-6efa-4b64-8089-0bf20b799004&siteType=1',
        itemGuid: '4af0b22a-6efa-4b64-8089-0bf20b799004',
        headline: "How to Build Your Youngest Employees' Skills",
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T14:06:34.163',
        updatedBy: null,
        updatedDate: null,
        articleId: '4af0b22a-6efa-4b64-8089-0bf20b799004',
      },
      {
        bookmarkId: 659926,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=83ec58c4-35f5-4e2f-869a-921c315aa60c&siteType=1',
        itemGuid: '83ec58c4-35f5-4e2f-869a-921c315aa60c',
        headline: 'Calif High Court to Review Meal and Rest Period Premium Calculation Case ',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T14:06:21.173',
        updatedBy: null,
        updatedDate: null,
        articleId: '83ec58c4-35f5-4e2f-869a-921c315aa60c',
      },
      {
        bookmarkId: 659907,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=1be4a0e9-4825-4e4f-a991-bc03eb41f6f7&siteType=1',
        itemGuid: '1be4a0e9-4825-4e4f-a991-bc03eb41f6f7',
        headline: '5 Steps for Adopting a Four-Day Workweek',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T13:57:00.783',
        updatedBy: null,
        updatedDate: null,
        articleId: '1be4a0e9-4825-4e4f-a991-bc03eb41f6f7',
      },
      {
        bookmarkId: 659905,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=d1988ca8-b8e7-488b-936d-9c1e48410828&siteType=1',
        itemGuid: 'd1988ca8-b8e7-488b-936d-9c1e48410828',
        headline: 'How Income-Advance Loans Help Financially Stressed Employees',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T13:56:51.427',
        updatedBy: null,
        updatedDate: null,
        articleId: 'd1988ca8-b8e7-488b-936d-9c1e48410828',
      },
      {
        bookmarkId: 659777,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=4fa26a47-c478-45d6-9bdd-7cf4f64b4f82&siteType=1',
        itemGuid: '4fa26a47-c478-45d6-9bdd-7cf4f64b4f82',
        headline: 'Head Chef Not Entitled to Overtime Pay Because Executive Exemption Applied',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T11:55:23.67',
        updatedBy: null,
        updatedDate: null,
        articleId: '4fa26a47-c478-45d6-9bdd-7cf4f64b4f82',
      },
      {
        bookmarkId: 659776,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=f9aa76c9-80a5-4483-841c-2a1f82132a8b&siteType=1',
        itemGuid: 'f9aa76c9-80a5-4483-841c-2a1f82132a8b',
        headline: 'Kickstarter Employees Unionize in Historic Move for Tech Industry',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T11:55:05.757',
        updatedBy: null,
        updatedDate: null,
        articleId: 'f9aa76c9-80a5-4483-841c-2a1f82132a8b',
      },
      {
        bookmarkId: 659775,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=01f39cee-3920-4fa6-9351-05a0bfc3f879&siteType=1',
        itemGuid: '01f39cee-3920-4fa6-9351-05a0bfc3f879',
        headline: 'Lean and Six Sigma in Talent Acquisition',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T11:54:59.393',
        updatedBy: null,
        updatedDate: null,
        articleId: '01f39cee-3920-4fa6-9351-05a0bfc3f879',
      },
      {
        bookmarkId: 659773,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=377dadb8-114b-4d1a-9418-f67ca539b0f8&siteType=1',
        itemGuid: '377dadb8-114b-4d1a-9418-f67ca539b0f8',
        headline: 'What Does the Kronos and Ultimate Software Merger Mean for HR?',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T11:54:39.567',
        updatedBy: null,
        updatedDate: null,
        articleId: '377dadb8-114b-4d1a-9418-f67ca539b0f8',
      },
      {
        bookmarkId: 659771,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=8ce0924f-86e3-4825-84ce-cf571c36ece4&siteType=1',
        itemGuid: '8ce0924f-86e3-4825-84ce-cf571c36ece4',
        headline: 'Fired Worker in Massachusetts Gets Triple Jury Award for Unpaid Commissions',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T11:54:10.137',
        updatedBy: null,
        updatedDate: null,
        articleId: '8ce0924f-86e3-4825-84ce-cf571c36ece4',
      },
      {
        bookmarkId: 659695,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=290d0fa0-a724-412c-aa84-374b8b792412&siteType=1',
        itemGuid: '290d0fa0-a724-412c-aa84-374b8b792412',
        headline: 'As Coronavirus Spreads, Prepare Infectious-Disease Plans',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T10:11:58.287',
        updatedBy: null,
        updatedDate: null,
        articleId: '290d0fa0-a724-412c-aa84-374b8b792412',
      },
      {
        bookmarkId: 659633,
        ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
        bookmarkTypeId: 1,
        siteTypeId: 1,
        bookmarkLink:
          '/_layouts/15/SHRM.Core/ajax/get/ItemUrl.aspx?ItemGuid=29790f50-def8-4f31-b991-9926546f28e8&siteType=1',
        itemGuid: '29790f50-def8-4f31-b991-9926546f28e8',
        headline: 'Workplace Protections Growing for Cannabis Consumers',
        subheading: null,
        notes: null,
        addedBy: 'WebUser',
        addedDate: '2020-02-25T08:26:53.34',
        updatedBy: null,
        updatedDate: null,
        articleId: '29790f50-def8-4f31-b991-9926546f28e8',
      },
    ];

    const totalCount = bookmarksMock.length;
    let totalPages = 0;

    if (pageSize < 1) {
      pageSize = 10;
    }

    if (pageNumber < 1) {
      pageNumber = 1;
    }

    if (totalCount > 0) {
      totalPages = Math.ceil(totalCount / pageSize);
      const indexOfLastItem = pageNumber * pageSize;
      const indexOfFirstItem = indexOfLastItem - pageSize;

      bookmarksMock = bookmarksMock.slice(indexOfFirstItem, indexOfLastItem);
    }

    const container: IBookmarksContainer = {
      bookmarks: bookmarksMock,
      totalCount: totalCount,
      totalPages: totalPages,
    };

    return new Promise((resolve, reject) => {
      resolve({
        data: container,
      });
      throw new Error('Mock exception!');
    });
  }

  function updateNote(data: IBookmarkUpdate): any {
    return new Promise((resolve, reject) => {
      resolve({
        data: data,
      });
      throw new Error('Mock exception!');
    });
  }

  function deleteBookmark(ssoUUId: string, bookmarkId: number) {
    return new Promise((resolve, reject) => {
      resolve({
        data: 'mock success message',
      });
      throw new Error('Mock exception!');
    });
  }

  return {
    getBookmarksPaged,
    updateNote,
    deleteBookmark,
  };
}

export default bookmarkServiceMock;
